module.exports = __webpack_public_path__ + "static/media/snfood.933fc693.png";